import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PromptOverride } from "@entities/generation-setting";

/** 上書きの器。無ければサーバーは空の器を返す（404 にしない）。 */
export type TaskPromptOverrides = {
    baselineFingerprint: string;
    updatedAt: string;
    updatedBy: string;
    frozen: boolean;
    prompts: { [id: string]: PromptOverride };
};

/**
 * タスクの上書きを読む。
 *
 * 再生成では、元タスクに付いていた上書きが**作成の時点で新しいタスクへ引き継がれる**
 * （`hand_over_overrides`）。書き込みは全置換なので、手元の差分を送る前にここを読んで重ねないと、
 * 引き継がれたコンソール側の調整が消える。
 */
export async function getTaskOverrides(
    projectId: string,
    taskId: string
): Promise<TaskPromptOverrides> {
    const res = await fetchWithAuth(
        `/generation-tasks/${encodeURIComponent(taskId)}/overrides` +
            `?projectId=${encodeURIComponent(projectId)}`,
        { headers: { Accept: "application/json" } }
    );
    if (!res.ok) throw await ApiError.fromResponse(res, "プロンプトの調整を取得できませんでした");
    const body = (await res.json()) as { overrides: TaskPromptOverrides };
    return body.overrides;
}
